import { type MouseEventHandler } from 'react';
import { type Theme, Grid } from '@mui/material';
import Image from 'components/medias/Image';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  category: {
    transform: 'scale(0.95)',
    transition: 'all .2s ease-in-out',
    verticalAlign: 'bottom',
    width: '85%',

    '&:hover': {
      transform: 'scale(1)',
    },

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}), { name: 'HomeCategory' });

type HomeCategoryProps = {
  alt: string;
  image: string;
  onClick: MouseEventHandler;
}

const HomeCategory = ({ alt, image, onClick }: HomeCategoryProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid item md={6} xs={12}>
      <Image
        className={classes.category}
        alt={alt}
        src={image}
        onClick={onClick}
      />
    </Grid>
  );
}

export default HomeCategory;